// extracted by mini-css-extract-plugin
export default {"link":"ModalSummaryOfAnswersForInventoryNumberFieldForShowHide_link__PRYZq","clickable":"ModalSummaryOfAnswersForInventoryNumberFieldForShowHide_clickable__w7uxc"};